import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import ToolTip from "@material-ui/core/Tooltip";
import { instance } from "Actions/AxiosInstance";
import { CheckActionPermission } from "Actions/commonAction";
import reviewFormConcept from "Assets/Images/career_progress.svg";
import addIcon from "Assets/newicons/action/add-round/glyph/add-round-filled-blue-16px.svg";
import checkRoundGreen from "Assets/newicons/notify/check-round/glyph/check-round-outline-green-16px.svg";
import classNames from "classnames";
import DynamicForm from "Component/DynamicForm";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import DrawerHeader from "Component/Headers/drawerHeader";
import PageHeader from "Component/Headers/pageHeader";
import SearchSq from "Component/Material-ui/SearchSq";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import headersList from "Constants/headersList";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { isSpaceInString } from "Utils";
import CustomLoader from "Component/CustomLoader";

import {
  CreateComp,
  List,
  TDTypeConsts,
} from "../../../../business-configration/commons";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    width: "100%",
  },

  drawerPaper: {
    width: "40%",
    height: "100vh",
  },
});

const allTags = [];
class CompetencyRepository extends Component {
  constructor(props) {
    super(props);
    this.state = {
      competencyname: "",
      permissions: { editable: true, readonly: true },
      listdata: [],
      backupList: [],
      tags: [],
      isedit: false,
      backuptags: null,
      competencyid: null,
      data: false,
      open: false,
      row: null,
      createmenu: false,
      create_anchorEl: null,
      selecteddata: null,
      tabvalue: 0,
      value: [],
      options: allTags.map((tag) => ({
        value: tag.value,
        label: tag.label,
      })),
      searchValue: "",
      headers: [
        {
          key: "competencyname",
          name: "Competency name",
          type: TDTypeConsts.DEPARTMENT_NAME,
          style: { textAlign: "left", width: "20%" },
        },
        {
          key: "description",
          name: "Description",
          type: TDTypeConsts.COMPETANCY_DESCRIPTION,
          style: { textAlign: "left" },
        },
        {
          key: "tags",
          name: "Tags",
          type: TDTypeConsts.TAGS,
          style: { textAlign: "left" },
        },
        // {
        //   key: "isactive",
        //   name: "Status",
        //   type: TDTypeConsts.ATIVEINACTIVE,
        // },
        {
          key: "isactive",
          name: "Status",
          type: TDTypeConsts.STATUS_ACTIVE_INACTIVE,
        },
        // {
        //   key: "edit1",
        //   type: TDTypeConsts.EDIT_WITHOUT_HEADER,
        // },
        // {
        //   key: "delete1",
        //   type: TDTypeConsts.DELETE_WITHOUT_HEADER,
        // },
        {
          key: "",
          name: "",
          type: TDTypeConsts.MORE_OPTIONS,
        },
      ],
      CustomHeaders: [
        {
          key: "competencyname",
          name: "Competency name",
          type: TDTypeConsts.DEPARTMENT_NAME,
          style: { textAlign: "left", width: "20%" },
        },
        {
          key: "description",
          name: "Description",
          type: TDTypeConsts.COMPETANCY_DESCRIPTION,
          style: { textAlign: "left" },
        },
        {
          key: "tags",
          name: "Tags",
          type: TDTypeConsts.TAGS,
          style: { textAlign: "left" },
        },

        {
          key: "isactive",
          name: "Status",
          type: TDTypeConsts.STATUS_ACTIVE_INACTIVE,
        },

        {
          key: "",
          name: "",
          type: TDTypeConsts.MORE_OPTIONS,
        },
      ],
      DefaultHeaders: [
        {
          key: "competencyname",
          name: "Competency name",
          type: TDTypeConsts.DEPARTMENT_NAME,
          style: { textAlign: "left", width: "20%" },
        },
        {
          key: "description",
          name: "Description",
          type: TDTypeConsts.COMPETANCY_DESCRIPTION,
          style: { textAlign: "left" },
        },
        {
          key: "tags",
          name: "Tags",
          type: TDTypeConsts.TAGS,
          style: { textAlign: "left" },
        },

        {
          key: "isactive",
          name: "Status",
          type: TDTypeConsts.STATUS_ACTIVE_INACTIVE,
        },

        {
          key: "",
          name: "",
          type: TDTypeConsts.MORE_OPTIONS,
        },
      ],
    };

    this.handleChange = this.handleChange.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
    this.createNewMenuClose = this.createNewMenuClose.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleChange1 = this.handleChange.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("competency");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getData();
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.MORE_OPTIONS,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selecteddata: row,
    });
  }

  handleBlur(key, value) {
    const { tags, backuptags } = this.state;
    // if (value && value.length > 50) {
    //   this.props.enqueueSnackbar("maximum limit should not be greater than 50", { variant: "error" });
    //   return;
    // } else
    if (value) {
      tags.push(backuptags);
      // skill.push(backupskill);
      this.setState({
        tags,
        backuptags: "",
        [key]: "",
        // skill,
      });
    }
  }

  handleDelete(index) {
    console.log("index: ", index);
    const { tags } = this.state;
    console.log("tags: ", tags);
    // const { skill } = this.state.postData.jobdetail;
    tags.splice(index, 1);
    console.log("tags: ", tags);
    // skill.splice(index, 1);
    this.setState({
      tags,
      // skill,
    });
  }

  handleChange1(newValue) {
    if (newValue && newValue.length < 6) {
      this.setState({ value: newValue });
    }
  }

  handleCreate(inputValue) {
    this.setState({ isLoading: true });
    setTimeout(() => {
      const { options, value } = this.state;
      const newOption = { value: inputValue, label: inputValue };
      const x = [...options, newOption];
      const y = [...value, newOption];
      this.setState({
        isLoading: false,
        options: x.length > 5 ? [...options] : x,
        value: y.length > 5 ? [...value] : y,
      });
    }, 1000);
  }

  createNewMenuClose() {
    this.setState({ createmenu: false });
  }

  changeStatus(row, key, value) {
    const { selecteddata } = this.state;
    const data = {
      competencyid: selecteddata.competencyid
        ? selecteddata.competencyid
        : null,
      isactive: !selecteddata.isactive,
    };
    instance.post("perform/activeinactivecompetency", data).then((res) => {
      this.setState(
        {
          // isActive: res.data.result,
          createmenu: false,
        },
        () => this.getData(),
      );
    });
  }

  getData() {
    const id = this.state.tabvalue == 0 ? 2 : 1;
this.setState({
  isLoading:true
}, () => {
  instance
  .get(`perform/getcompetency/${id}`)
  .then((result) => {
    console.log("result: ", result);
    this.props.closeSnackbar();
    this.setState({
      listdata: result.data.result.map((x) => ({
        ...x,
        hideedit: x.systemcompetencyid ? true : false,
        hidedelete: x.systemcompetencyid ? true : false,
      })),
      backupList: result.data.result.map((x) => ({
        ...x,
        hideedit: x.systemcompetencyid ? true : false,
        hidedelete: x.systemcompetencyid ? true : false,
      })),
      data: true,
      isLoading:false
    });
  })
  .catch((error) => {
    this.setState({
      listdata: [],
      data: true,
      isLoading:false
    });
    this.props.enqueueSnackbar(
      error.response ? error.response.data.error.message : error.message,
      { variant: "error" },
    );
  });
})

   
  }

  // getTemplates() {
  //   const { value, lettercategoryid } = this.state;
  //   instance
  //     .post("letter/getalllettertemplate", {
  //       iscustom: value == 0 ? false : true,
  //       lettercategoryid,
  //     })
  //     .then((resp) => {
  //       if (value == 0) {
  //         this.setState({
  //           defaultTemplates: {
  //             ...this.state.defaultTemplates,
  //             data: resp.data.result,
  //           },
  //           backupList: resp.data.result,
  //         });
  //       } else {
  //         this.setState({
  //           customTemplates: {
  //             ...this.state.customTemplates,
  //             data: resp.data.result,
  //           },
  //           backupList: resp.data.result,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       this.props.enqueueSnackbar(
  //         error.response ? error.response.data.error.message : error.message,
  //         { variant: "error" },
  //       );
  //     });
  // }

  searchTemplate = (e) => {
    const { listdata, backupList } = this.state;
    console.log("backupList: ", backupList);
    console.log("listdata: ", listdata);
    // const list = value == 0 ? listdata.data : listdata.data;
    const filterList = backupList.filter(
      (item) =>
        item.competencyname
          .toLowerCase()
          .search(e.target.value.toLowerCase()) !== -1,
    );
    this.setState({
      searchValue: e.target.value,
      listdata: e.target.value ? filterList : backupList,
    });
  };

  onEdit() {
    const { selecteddata } = this.state;
    // issystem
    instance
      .get(
        `perform/getcompetency/3/${selecteddata && selecteddata.competencyid}`,
      )
      .then((result) => {
        this.setState({
          competencyname: result.data.result[0].competencyname,
          description: result.data.result[0].description,
          competencyid: result.data.result[0].competencyid,
          open: true,
          createmenu: false,
          tags: result.data.result[0].tags,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  onDelete(row) {
    // const { row } = this.state;
    console.log("row: ", row);
    const { selecteddata } = this.state;

    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            this.setState({
              createmenu: false,
            });
            this.props.closeSnackbar();
            instance
              .delete(
                `perform/deletecompetency/${
                  selecteddata ? selecteddata.competencyid : ""
                }`,
              )
              .then(() => {
                this.props.enqueueSnackbar("Deleted successfully", {
                  variant: "success",
                });
                // this.setState(
                //   {
                //     backupList: [],
                //     totalcount: 1,
                //     data: [],
                //     offset: 0,
                //     createmenu: false,
                //   },
                //   () => {
                //     this.getReviewStructure();
                //   },
                // );
                this.setState(
                  {
                    selecteddata: null,
                    data: [],
                    offset: 0,
                    backupList: [],
                    totalcount: 1,
                    createmenu: false,
                  },
                  () => {
                    this.getData();
                  },
                );
              })
              .catch((error) => {
                this.setState({
                  createmenu: false,
                });
                this.props.closeSnackbar();
                // const msg = error.response && error.response.data && error.response.data.error.message;
                this.props.enqueueSnackbar(
                  "you can not delete this focus area as it is linked to review form" ||
                    "",
                  {
                    variant: "error",
                  },
                );
              });
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() =>
            this.setState({ createmenu: false }, () =>
              this.props.closeSnackbar(),
            )
          }
        >
          No
        </Button>,
      ],
    });
  }

  handleChange(value, key) {
    if (key == "backuptags") {
      this.setState({
        isedit: true,
        [key]: value,
      });
    } else {
      this.setState({
        [key]: value,
      });
    }
  }

  onCreate() {
    this.setState({
      open: !this.state.open,
      row: null,
    });
  }

  onSave() {
    const { description, competencyid, tags } = this.state;
    if (this.state.competencyname && !isSpaceInString(this.state.competencyname)) {
      this.state.competencyname = this.state.competencyname.trim();
    }
    if (description.length >= 254) {
      this.props.enqueueSnackbar(
        "please enter description within 254 character",
        { variant: "error" },
      );
    } else if (this.state.competencyname) {
      
  
      instance
        .post(`perform/createcompetency`, {
          competencyid,
          competencyname: this.state.competencyname,
          description,
          tags,
        })
        .then((result) => {
          console.log("result: ", result);
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
          this.setState(
            {
              competencyname: null,
              open: false,
              description: null,
              competencyid: null,
              createmenu: false,
              tags: [],
            },
            () => {
              this.getData();
            },
          );
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  handleTabChange(tabvalue) {
    this.setState(
      {
        tabvalue,
      },
      () => {
        this.getData();
      },
    );
  }

  render() {
    const {
      listdata,
      data,
      selecteddata,
      tabvalue,

      // value,
      //  allTags,
    } = this.state;
    const { classes } = this.props;

    // const allTags = allTags.map((tag) => ({
    //   value: tag.value,
    //   label: tag.label,
    // }));
    return (
      <div className="innerwrapper-full-width">
        <Helmet>
          <title>{headersList.Config.CompetencyRepository.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            
         <div>


            {data && listdata.length > 0 && (
              <div className="content-outer-wrapper">
                <Grid container>
                  <Grid item md={4} sm={12}>
                    <PageHeader header="Focus area" />
                  </Grid>
                  <Grid
                    item
                    md={8}
                    sm={12}
                    justify="flex-end"
                    className="display-flex"
                  >
                    <div className="floatleft margin-right-16">
                      <SearchSq
                        placeholder="Search templates"
                        value={this.state.searchValue}
                        // onChange={this.searchTemplate}
                        onChange={(e) => this.searchTemplate(e)}
                      />
                    </div>
                    {this.state.permissions.editable && (
                      <Button
                        variant="contained"
                        className="btn btn-primary-md-blue"
                        color="primary"
                        onClick={this.onCreate}
                      >
                        Create
                      </Button>
                    )}
                  </Grid>
                </Grid>
                <Tabs
                  value={tabvalue}
                  // onChange={this.handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  scrollButtons="auto"
                >
                  <Tab
                    label="Default"
                    className="width50"
                    onClick={() => this.handleTabChange(0)}
                  />
                  <Tab
                    label="Custom"
                    className="width50"
                    onClick={() => this.handleTabChange(1)}
                  />
                </Tabs>
                <div className="tab-border margin-bottom-16"></div>
                {this.state.isLoading ?
  <CustomLoader/>

     :         
     <div className="margin-top-16">
     <List
                  list={this.state.listdata}
                  headers={this.state.headers}
                  permissions={this.state.permissions}
                  onEdit={this.onEdit}
                  onDelete={this.onDelete}
                  changeStatus={this.changeStatus}
                  module="competency"
                  showOnlyList
                  onMoreOptionClick={(e, row) => this.onMoreOptionClick(e, row)}
                />
                </div>
            }
               
              </div>
            )}

            {data && listdata.length == 0 && (
              <div className="content-outer-wrapper">
                <CreateComp
                  text="text"
                  heading="Concept of Aptitude focus area"
                  onCreate={this.onCreate}
                  imageSrc={reviewFormConcept}
                  permissions={this.state.permissions}
                />
              </div>
            )}

            <Drawer
              anchor="right"
              open={this.state.open}
              onClose={() =>
                this.setState({
                  competencyname: null,
                  open: false,
                  description: null,
                  competencyid: null,
                  tags: [],
                })
              }
              classes={{
                paper: classNames(classes.drawerPaper, "planner-drawer"),
              }}
            >
              <div style={{ padding: 16, paddingBottom: 0 }}>
                <DrawerHeader
                  header="New focus area"
                  isbackarrow={false}
                  closeDrawer={() =>
                    this.setState({
                      competencyname: null,
                      open: false,
                      description: null,
                      competencyid: null,
                      tags: [],
                    })
                  }
                />
                {this.state.open && (
                  <div
                    className="thin-scroll"
                    style={{ height: "82vh", overflowY: "auto" }}
                  >
                    <p className="normal-dark margin-bottom-16 ">
                      👉 &nbsp; &nbsp;Enter the focus area you wish to create
                      and write a short description.
                    </p>

                    <DynamicForm
                      fields={textinputconverter({
                        value: this.state.competencyname,
                        placeholder: "Enter name",
                        label: "Focus area name",
                      })}
                      onChange={(value) => {
                        this.handleChange(value, "competencyname");
                      }}
                    />
                    <DynamicForm
                      className="width50"
                      fields={textareainputconverter({
                        value: this.state.description,
                        label: "Description",
                        placeholder: "Enter description",
                      })}
                      onChange={(value) => {
                        this.handleChange(value, "description");
                      }}
                    />
                    <p className="normal-dark margin-bottom-8 ">
                      👉 &nbsp; &nbsp;Assign tags to easily search this focus
                      area.
                    </p>

                    {/* <CreatableSelect
                  isClearable={true}
                  isDisabled={isLoading}
                  isLoading={isLoading}
                  onChange={this.handleChange1}
                  onCreateOption={this.handleCreate}
                  options={allTags}
                  value={value}
                  isMulti
                  placeholder="Attach tags"
                /> */}
                    <div
                      className="position-rel"
                      style={{
                        // bottom: 0,
                        left: 0,
                        width: "calc(100% - 12px)",
                        // padding: "8px 24px",
                        // marginLeft: 12,
                      }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value: this.state.backuptags,
                          placeholder: "Enter tag",
                          label: "",
                        })}
                        onChange={(e) => {
                          this.handleChange(e, "backuptags");
                        }}
                      />
                      <div
                        style={{ position: "absolute", right: 14, top: 12 }}
                        onClick={() => {
                          this.handleBlur("backuptags", this.state.backuptags);
                        }}
                      >
                        {this.state.isedit ? (
                          <img src={checkRoundGreen}></img>
                        ) : (
                          <img src={addIcon}></img>
                        )}
                      </div>
                    </div>

                    {this.state.tags &&
                      this.state.tags.length > 0 &&
                      this.state.tags.map((x, index) => (
                        <ToolTip title={x} placement="top">
                          <Chip
                            label={x}
                            onDelete={() => this.handleDelete(index)}
                            color="primary"
                            className="ellipsis"
                            variant="outlined"
                            style={{ marginRight: 16, marginBottom: 8 }}
                          />
                        </ToolTip>
                      ))}

                    {/* <DynamicForm
                  className="width50"
                  fields={textareainputconverter({
                    value: this.state.description,
                    label:
                      "Tags may include aliases, departments, and designations to help identify use cases.",
                    placeholder: "Add tags",
                  })}
                  onChange={(value) => {
                    this.handleChange(value, "description");
                  }}
                />
                <p className="input-label" style={{ marginTop: -12 }}>
                  Use commas to separate each tag. Tags are not case sensitive.
                </p> */}

                    <div
                      className="helping-hand-wrapper margin-top-16"
                      style={{
                        padding: 16,
                        width: "calc(100% - 34px)",
                        marginBottom: 40,
                      }}
                    >
                      <p className="helping-hand-text text-center margin-bottom-16">
                        Helping Hand 👋 - Example
                      </p>
                      <p className="small-dark">
                        communication, connect, inform, manager, sales
                      </p>
                    </div>
                  </div>
                )}
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    marginLeft: -16,
                    width: "calc(100% - 32px)",
                    padding: "8px 16px",
                    background: "#fff",
                  }}
                >
                  <span className="floatleft">
                    <Button
                      variant="contained"
                      className="btn btn-trans"
                      color="primary"
                      onClick={() =>
                        this.setState({
                          competencyname: null,
                          open: false,
                          description: null,
                          competencyid: null,
                        })
                      }
                    >
                      Cancel
                    </Button>
                  </span>
                  <span className="floatright">
                    <Button
                      variant="contained"
                      className="btn btn-primary-md-blue"
                      color="primary"
                      onClick={this.onSave}
                    >
                      Save
                    </Button>
                  </span>
                </div>
              </div>
            </Drawer>
            <Popover
              open={this.state.createmenu}
              anchorEl={this.state.create_anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              onClose={this.createNewMenuClose}
              className="margin-top-8"
            >
              <Paper style={{ width: 190 }}>
                <div>
                  <MenuListComponent>
                    {selecteddata && !selecteddata.hideedit && (
                      <ListItem
                        className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                        onClick={this.onEdit}
                      >
                        <ListItemText style={{ padding: 0 }}>
                          <span className="small-dark-secondary">Edit </span>
                        </ListItemText>
                      </ListItem>
                    )}
                    {selecteddata && !selecteddata.hidedelete && (
                      <ListItem
                        className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                        onClick={this.onDelete}
                      >
                        <ListItemText style={{ padding: 0 }}>
                          <span className="small-dark-secondary">Delete </span>
                        </ListItemText>
                      </ListItem>
                    )}

                    <ListItem
                      className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                      onClick={this.changeStatus}
                    >
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">
                          Make{" "}
                          {selecteddata && selecteddata.isactive
                            ? "inactive "
                            : "active"}
                        </span>
                      </ListItemText>
                    </ListItem>
                  </MenuListComponent>
                </div>
              </Paper>
            </Popover>
          </div>
        
          </div>
        
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(CompetencyRepository)));
